import { Radio } from "@mui/material";
import { useRef, useState } from "react";
import ICONS from "../../../../assets/Icons";
import TextInputField from "../../CommonInputFields/TextInputField";
import TickerAnimation from "../../TickerAnimation";

const AccountName = ({
  handleChange,
  accountNameValidation,
  accountName,
  type,
  handleDivBtn,
  handleRadioBtn,
  selectedRadioValue,
  legalName,
  placeHolder,
  userName,
  nameSubLabel,
}) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const computeVariant = (value, focused, minLen) => {
    const trimmedValue = (value ?? "").trim();
    const length = trimmedValue.length;

    if (focused && length === 0) {
      return "typing";
    }

    if (!focused && length === 0) {
      return "default";
    }

    if (focused && length > 0 && length < minLen) {
      return "typing";
    }

    if (!focused && length > 0 && length < minLen) {
      return "error";
    }

    if (length >= minLen) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <div className="flex flex-col relative w-width-full">
      <div className="py-padding-md bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="text-text-primary font-semibold text-base px-padding-md">
            Account Name
          </div>
          <div className="px-padding-md">
            <TextInputField
              ref={inputRef}
              // variant={computeVariant(accountName, isFocused)}
              variant={computeVariant(
                accountName,
                isFocused,
                selectedRadioValue === "customname" ? 3 : 1,
              )}
              placeholder={placeHolder ? placeHolder : "Account name"}
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              value={accountName}
              name="account_name"
              adornment={ICONS.PROFILE}
              onInput={(e) => {
                const newValue = e.target.value;
                handleChange(e);
                if (
                  (selectedRadioValue === "legalname" &&
                    newValue.trim().toLowerCase() !==
                      legalName?.trim().toLowerCase()) ||
                  (selectedRadioValue === "username" &&
                    newValue.trim().toLowerCase() !==
                      userName?.trim().toLowerCase())
                ) {
                  handleDivBtn("customname");
                }
              }}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              isFullWidth={true}
            />

            <div className="text-font-xs font-normal text-text-primary mt-margin-xs">
              Note: Minimum 3 characters required.
            </div>
          </div>
          <div className="flex flex-col align-center gap-gap-md mobile-account-name w-width-full px-padding-sm">
            <div className="Qsmd:max-w-[var(--totp-box-width)] flex flex-col gap-gap-md px-padding-sm">
              <div
                className={`flex flex-row items-center p-padding-sm w-width-full rounded-border-radius-md mobile-account-name-div overflow-hidden ${
                  selectedRadioValue === "legalname"
                    ? "bg-text-primary cursor-default"
                    : "bg-primary-nav cursor-pointer global-hover-white relative z-z-index-base"
                }`}
                onClick={() => {
                  handleDivBtn("legalname");
                }}
              >
                <Radio
                  checked={selectedRadioValue === "legalname"}
                  onChange={handleRadioBtn}
                  value="legalname"
                  name="radio-buttons"
                  inputProps={{ "aria-label": "A" }}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      width: "var(--icon-md)",
                      height: "var(--icon-md)",
                    },
                    "color":
                      selectedRadioValue === "legalname"
                        ? "var(--positive-act)"
                        : "var(--text-primary)",
                    "&.Mui-checked": {
                      color:
                        selectedRadioValue === "legalname"
                          ? "var(--positive-act)"
                          : "var(--text-primary)",
                    },
                    "padding": "var(--padding-base) var(--padding-sm)",
                  }}
                />

                <div className="flex flex-col justify-center gap-gap-xs flex-1 min-w-0 overflow-hidden">
                  <p
                    className={`text-font-sm font-semibold truncate ${
                      selectedRadioValue === "legalname"
                        ? "text-primary-bg"
                        : "text-text-primary"
                    }`}
                  >
                    <TickerAnimation text={legalName} />
                  </p>

                  <p
                    className={`text-font-xs font-normal truncate ${
                      selectedRadioValue === "legalname"
                        ? "text-text-disabled"
                        : "text-text-secondary"
                    }`}
                  >
                    {nameSubLabel || "Autofill PAN legal name"}
                  </p>
                </div>
              </div>
              {type === "user" && (
                <div
                  className={`flex flex-row items-center w-width-full rounded-border-radius-md p-padding-sm mobile-account-name-div ${!userName ? "pointer-events-none opacity-light-opacity" : ""} ${
                    selectedRadioValue === "username"
                      ? "bg-text-primary cursor-default"
                      : "bg-primary-nav cursor-pointer global-hover-white relative z-z-index-base"
                  }`}
                  onClick={() => {
                    handleDivBtn("username");
                  }}
                >
                  <Radio
                    checked={selectedRadioValue === "username"}
                    onChange={handleRadioBtn}
                    value="username"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "B" }}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        width: "var(--icon-md)",
                        height: "var(--icon-md)",
                      },
                      "color":
                        selectedRadioValue === "username"
                          ? "var(--positive-act)"
                          : "var(--text-primary)",
                      "&.Mui-checked": {
                        color:
                          selectedRadioValue === "username"
                            ? "var(--positive-act)"
                            : "var(--text-primary)",
                      },
                      "padding": "var(--padding-base) var(--padding-sm)",
                    }}
                  />
                  <div className="flex flex-col justify-center gap-gap-xs flex-1 min-w-0 overflow-hidden">
                    <div
                      className={`text-font-sm font-semibold truncate ${
                        selectedRadioValue === "username"
                          ? "text-primary-bg"
                          : "text-text-primary cursor-pointer"
                      }`}
                    >
                      <TickerAnimation
                        text={userName ? userName : "Username"}
                      />
                    </div>
                    <p
                      className={`text-font-xs font-normal truncate ${
                        selectedRadioValue === "username"
                          ? "text-text-disabled"
                          : "text-text-secondary"
                      }`}
                    >
                      Autofill linked username
                    </p>
                  </div>
                </div>
              )}

              <div
                className={`flex flex-row items-center w-width-full rounded-border-radius-md p-padding-sm mobile-account-name-div ${
                  selectedRadioValue === "customname"
                    ? "bg-text-primary cursor-default"
                    : "bg-primary-nav cursor-pointer global-hover-white relative z-z-index-base"
                }`}
                onClick={() => {
                  handleDivBtn("customname");
                }}
              >
                <Radio
                  checked={selectedRadioValue === "customname"}
                  onChange={handleRadioBtn}
                  value="customname"
                  name="radio-buttons"
                  inputProps={{ "aria-label": "B" }}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      width: "var(--icon-md)",
                      height: "var(--icon-md)",
                    },
                    "color":
                      selectedRadioValue === "customname"
                        ? "var(--positive-act)"
                        : "var(--text-primary)",
                    "&.Mui-checked": {
                      color:
                        selectedRadioValue === "customname"
                          ? "var(--positive-act)"
                          : "var(--text-primary)",
                    },
                    "padding": "var(--padding-base) var(--padding-sm)",
                  }}
                />
                <div className="flex flex-col gap-gap-xs">
                  <div
                    className={`text-font-sm font-semibold truncate ${
                      selectedRadioValue === "customname"
                        ? "text-primary-bg"
                        : "text-text-primary"
                    }`}
                  >
                    Custom name
                  </div>
                  <p
                    className={`text-font-xs font-normal truncate ${
                      selectedRadioValue === "customname"
                        ? "text-text-disabled"
                        : "text-text-secondary"
                    }`}
                  >
                    {selectedRadioValue === "customname"
                      ? "Custom account name"
                      : "Enter custom account name"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountName;
